"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Obfuscation = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var textbox_1 = require("../textbox");
var classnames_1 = require("../util/classnames");
var vdl_prefix_1 = require("../util/vdl-prefix");
var _1 = require("../util/_");
var eye_1 = __importDefault(require("adp-react-icons/lib/fa/eye"));
var eye_slash_1 = __importDefault(require("adp-react-icons/lib/fa/eye-slash"));
var Obfuscation = /** @class */function (_super) {
  __extends(Obfuscation, _super);
  function Obfuscation(props) {
    var _this = _super.call(this, props) || this;
    _this.onStateChange = function () {
      _this.setState({
        visible: !_this.state.visible
      });
    };
    _this.onObfuscatedTextboxChange = function (newValue) {
      _this.setState({
        value: newValue
      });
    };
    _this.state = {
      visible: props.defaultVisible,
      value: props.value ? props.value : ''
    };
    return _this;
  }
  Obfuscation.prototype.render = function () {
    var _a;
    var _b = this.props,
      className = _b.className,
      readOnly = _b.readOnly,
      renderLabel = _b.renderLabel,
      showLabel = _b.showLabel,
      hideLabel = _b.hideLabel;
    var customProps = _1.omit(this.props, Object.keys(Obfuscation.propTypes));
    var rootClasses = (_a = {}, _a[vdl_prefix_1.vdlPrefix('obfuscation')] = true, _a[vdl_prefix_1.vdlPrefix('obfuscation--visible')] = this.state.visible, _a);
    var icon = this.state.visible ? react_1.default.createElement(eye_slash_1.default, null) : react_1.default.createElement(eye_1.default, null);
    var labelText = renderLabel ? this.state.visible ? hideLabel || 'Hide' : showLabel || 'Show' : '';
    return react_1.default.createElement("div", __assign({}, customProps, {
      className: classnames_1.classNames(className, rootClasses)
    }), readOnly && react_1.default.createElement("div", {
      className: vdl_prefix_1.vdlPrefix('obfuscation__readonly')
    }, react_1.default.createElement("span", null, !this.state.visible ? this.props.mask : this.state.value), react_1.default.createElement("div", {
      className: vdl_prefix_1.vdlPrefix('obfuscation__toggle-readonly'),
      onClick: this.onStateChange
    }, icon, react_1.default.createElement("span", null, labelText))), !readOnly && react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(textbox_1.Textbox, {
      value: !this.state.visible ? this.props.mask : this.state.value,
      onChange: this.onObfuscatedTextboxChange,
      disabled: this.props.disabled,
      readOnly: !this.state.visible
    }), react_1.default.createElement("div", {
      className: vdl_prefix_1.vdlPrefix('obfuscation__toggle'),
      onClick: this.onStateChange
    }, icon, react_1.default.createElement("span", null, labelText))));
  };
  Obfuscation.propTypes = {
    mask: prop_types_1.default.string.isRequired,
    value: prop_types_1.default.string.isRequired,
    disabled: prop_types_1.default.bool,
    className: prop_types_1.default.string,
    children: prop_types_1.default.node,
    defaultVisible: prop_types_1.default.bool,
    readOnly: prop_types_1.default.bool,
    renderLabel: prop_types_1.default.bool,
    showLabel: prop_types_1.default.string,
    hideLabel: prop_types_1.default.string
  };
  Obfuscation.defaultProps = {
    defaultVisible: false
  };
  return Obfuscation;
}(react_1.default.PureComponent);
exports.Obfuscation = Obfuscation;